var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeArcBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 4017,
    viewBox: "0 0 1440 4017",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_489_880)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1440 607.178C1538.97 544.608 1597 468.539 1597 386.5C1597 173.042 1204.13 0 719.5 0C234.87 0 -158 173.042 -158 386.5C-158 468.815 -99.5776 545.119 0 607.808V4017H1440V607.178Z",
    fill: "url(#paint0_linear_489_880)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_489_880",
    x1: -1.5,
    y1: 4017,
    x2: 1440.5,
    y2: 4017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003AF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E90FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_489_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 4017,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeArcBackground);
export default __webpack_public_path__ + "static/media/home-arc-background.dbc1d0d5075e87c3a4da82800de1a278.svg";
export { ForwardRef as ReactComponent };